<template>
  <div class="tree-choice-body">
    <div class="tree-chioce-main">
      <div
        v-for="node of treeData"
        :key="node.id"
        :class="active.includes(node.id) ? 'active' : ''"
      >
      <!-- @click.stop="chooseNode(node)" -->
        <div class="choose-tem">
          <div class="left">
            <input type="checkbox"
              v-model="node.checked"
              :value="{'id': node.id, 'title': node.name}"
              :name="node.name"
              :id="node.id"
              @change="chooseNode(node)"
            >
            <label :for="node.id">{{node.name}}</label>
          </div>
          <img
          v-if="node.children && node.children.length"
          src="/img/ui/law/arrow_right.png"
          @click.stop="showNode(node)"
          >
        </div>
      </div>
    </div>
    <template v-if="children && children.length">
      <div>
        <tree
        :treeData="children"
        :chooseList="chooseList"
        >
        </tree>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  name: 'tree',
  props: {
    treeData: {
      type: Array,
      required: true,
      default: () => {}
    },
    chooseList: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      tree: null,
      level: 0,
      children: [],
      active: [],
      selected: []
    }
  },
  created () {
    const parent = this.$parent
    if (parent.isTree) {
      this.level = 1
      this.tree = parent
    } else {
      this.level = parent.level + 1
      this.tree = parent.tree
    }
  },
  methods: {
    chooseNode (node) {
      if (node.checked) {
        this.active.push(node.id)
        this.tree.$emit('choose-node', node)
      } else {
        const index = this.active.indexOf(node.id)
        if (index > -1) {
          this.active.splice(index, 1)
        }
        this.tree.$emit('delete-node', node)
      }
    },
    showNode (node) {
      this.children = []
      this.children = node.children || []
    }
  }
}
</script>
<style lang="stylus" scoped>
.tree-choice-body
  color #333
  display flex
  .tree-chioce-main
    overflow-y scroll
    width 3rem
    border-right 1px solid #DFDFDF
    height 6.5rem
    padding 0 0.2rem
    .active
      color #409EFF
    .choose-tem
      display flex
      justify-content space-between
      align-items center
      .left
        flex auto
        display flex
        align-items center
        input
          appearance auto
          width 0.2rem
          height 0.2rem
          flex-shrink 0
          margin-right 0.05rem
          margin-top 0
        label
          width 2rem
          overflow hidden
          white-space nowrap
          text-overflow ellipsis
        span
          flex auto
          overflow hidden
          white-space nowrap
          text-overflow ellipsis
          width 2rem
      img
        flex-shrink 0
        width 0.3rem
        height 0.2rem
</style>
